// extracted by mini-css-extract-plugin
export default {"root":"UserHistoryDrawer-root-201f8afdf8d9d34ca876ff028fa73d5d"};